import {
  InvoiceIcmsCstCsosn,
  IpiCst,
  PisCofinsCst,
} from './InvoiceNoteItems.types';

export const ipiCstOptions = [
  {
    value: IpiCst.INPUT_RECOVERY,
    label: '00 - Entrada com recuperação de crédito',
  },
  {
    value: IpiCst.INPUT_TAXED_ZERO_RATE,
    label: '01 - Entrada tributada com alíquota zero',
  },
  {
    value: IpiCst.INPUT_EXEMPT,
    label: '02 - Entrada isenta',
  },
  {
    value: IpiCst.INPUT_NON_TAXABLE,
    label: '03 - Entrada não-tributada',
  },
  {
    value: IpiCst.INPUT_IMMUNE,
    label: '04 - Entrada imune',
  },
  {
    value: IpiCst.INPUT_SUSPENDED,
    label: '05 - Entrada com suspensão',
  },
  {
    value: IpiCst.OTHER_INPUTS,
    label: '49 - Outras entradas',
  },
  {
    value: IpiCst.OUTPUT_TAXED,
    label: '50 - Saída tributada',
  },
  {
    value: IpiCst.OUTPUT_TAXED_ZERO_RATE,
    label: '51 - Saída tributada com alíquota zero',
  },
  {
    value: IpiCst.OUTPUT_EXEMPT,
    label: '52 - Saída isenta',
  },
  {
    value: IpiCst.OUTPUT_NON_TAXABLE,
    label: '53 - Saída não-tributada',
  },
  {
    value: IpiCst.OUTPUT_IMMUNE,
    label: '54 - Saída imune',
  },
  {
    value: IpiCst.OUTPUT_SUSPENDED,
    label: '55 - Saída com suspensão',
  },
  {
    value: IpiCst.OTHER_OUTPUTS,
    label: '99 - Outras saídas',
  },
];

export const pisCofinsCstOptions = [
  {
    value: PisCofinsCst.TAXABLE_OPERATION_NORMAL_RATE,
    label:
      '01 - Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))',
  },
  {
    value: PisCofinsCst.TAXABLE_OPERATION_DIFFERENTIATED_RATE,
    label:
      '02 - Operação Tributável (base de cálculo = valor da operação (alíquota diferenciada))',
  },
  {
    value: PisCofinsCst.TAXABLE_OPERATION_QUANTITY_RATE,
    label:
      '03 - Operação Tributável (base de cálculo = quantidade vendida x alíquota por unidade de produto)',
  },
  {
    value: PisCofinsCst.TAXABLE_OPERATION_MONOPHASIC,
    label: '04 - Operação Tributável (tributação monofásica (alíquota zero))',
  },
  {
    value: PisCofinsCst.TAXABLE_OPERATION_SUBSTITUTION,
    label: '05 - Operação Tributável (Substituição Tributária)',
  },
  {
    value: PisCofinsCst.TAXABLE_OPERATION_ZERO_RATE,
    label: '06 - Operação Tributável (alíquota zero)',
  },

  {
    value: PisCofinsCst.EXEMPT_OPERATION,
    label: '07 - Operação Isenta da Contribuição',
  },
  {
    value: PisCofinsCst.NON_INCIDENCE_OPERATION,
    label: '08 - Operação Sem Incidência da Contribuição',
  },
  {
    value: PisCofinsCst.OPERATION_WITH_SUSPENSION,
    label: '09 - Operação com Suspensão da Contribuição',
  },
  {
    value: PisCofinsCst.OTHER_OUTPUT_OPERATIONS,
    label: '49 - Outras Operações de Saída',
  },
  {
    value: PisCofinsCst.OPERATION_WITH_INTERNAL_TAX_CREDIT,
    label:
      '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno',
  },
  {
    value: PisCofinsCst.OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT,
    label:
      '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno',
  },
  {
    value: PisCofinsCst.OPERATION_WITH_EXPORT_REVENUE_CREDIT,
    label:
      '52 - Operação com Direito a Crédito – Vinculada Exclusivamente a Receita de Exportação',
  },
  {
    value:
      PisCofinsCst.OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT,
    label:
      '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno',
  },
  {
    value: PisCofinsCst.OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT,
    label:
      '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      PisCofinsCst.OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT,
    label:
      '55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      PisCofinsCst.OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT,
    label:
      '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED,
    label:
      '60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE,
    label:
      '61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_EXPORT_REVENUE,
    label:
      '62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE,
    label:
      '63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE,
    label:
      '64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação',
  },
  {
    value: PisCofinsCst.PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE,
    label:
      '65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      PisCofinsCst.PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE,
    label:
      '66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação',
  },
  {
    value: PisCofinsCst.OTHER_PRESUMED_CREDITS,
    label: '67 - Crédito Presumido - Outras Operações',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITHOUT_CREDIT,
    label: '70 - Operação de Aquisição sem Direito a Crédito',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITH_EXEMPTION,
    label: '71 - Operação de Aquisição com Isenção',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITH_SUSPENSION,
    label: '72 - Operação de Aquisição com Suspensão',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITH_ZERO_RATE,
    label: '73 - Operação de Aquisição a Alíquota Zero',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITHOUT_INCIDENCE,
    label: '74 - Operação de Aquisição; sem Incidência da Contribuição',
  },
  {
    value: PisCofinsCst.ACQUISITION_WITH_SUBSTITUTION,
    label: '75 - Operação de Aquisição por Substituição Tributária',
  },
  {
    value: PisCofinsCst.OTHER_INPUT_OPERATIONS,
    label: '98 - Outras Operações de Entrada',
  },
  {
    value: PisCofinsCst.OTHER_OPERATIONS,
    label: '99 - Outras Operações',
  },
];

export const optionsCstCodes = [
  { id: InvoiceIcmsCstCsosn.TRIBUTED_FULLY, code: '00' },
  { id: InvoiceIcmsCstCsosn.TRIBUTED_WITH_ICMS_SUBSTITUTION, code: '10' },
  { id: InvoiceIcmsCstCsosn.REDUCED_BASE, code: '20' },
  { id: InvoiceIcmsCstCsosn.EXEMPT_WITH_ICMS_SUBSTITUTION, code: '30' },
  { id: InvoiceIcmsCstCsosn.EXEMPT, code: '40' },
  { id: InvoiceIcmsCstCsosn.NOT_TRIBUTED, code: '41' },
  { id: InvoiceIcmsCstCsosn.SUSPENDED, code: '50' },
  { id: InvoiceIcmsCstCsosn.DEFERRED, code: '51' },
  { id: InvoiceIcmsCstCsosn.PREVIOUS_ICMS_SUBSTITUTION, code: '60' },
  { id: InvoiceIcmsCstCsosn.REDUCED_BASE_WITH_ICMS_SUBSTITUTION, code: '70' },
  { id: InvoiceIcmsCstCsosn.OTHERS, code: '90' },
];

export const optionsCsosnCodes = [
  {
    id: InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITH_CREDIT_PERMISSION,
    code: '101',
  },
  {
    id: InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION,
    code: '102',
  },
  {
    id: InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE,
    code: '103',
  },
  {
    id: InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITH_CREDIT_PERMISSION_AND_ICMS_BY_TAX_SUBSTITUTION,
    code: '201',
  },
  {
    id: InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITHOUT_CREDIT_PERMISSION_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION,
    code: '202',
  },
  {
    id: InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE_RANGE_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION,
    code: '203',
  },
  { id: InvoiceIcmsCstCsosn.IMMUNITY, code: '300' },
  { id: InvoiceIcmsCstCsosn.NOT_TAXED_UNDER_SIMPLES, code: '400' },
  {
    id: InvoiceIcmsCstCsosn.ICMS_PREVIOUSLY_CHARGED_BY_TAX_SUBSTITUTION,
    code: '500',
  },
  { id: InvoiceIcmsCstCsosn.CSOSN_OTHERS, code: '900' },
];

export const csosnCodes = [
  { id: 1, code: '101' },
  { id: 2, code: '102' },
  { id: 3, code: '103' },
  { id: 4, code: '201' },
  { id: 5, code: '202' },
  { id: 6, code: '203' },
  { id: 7, code: '300' },
  { id: 8, code: '400' },
  { id: 9, code: '500' },
  { id: 10, code: '900' },
];

export const InvoiceCstCsosnCodes: Record<string, string> = {
  //---------------CST---------------
  [InvoiceIcmsCstCsosn.TRIBUTED_FULLY]: '00',
  [InvoiceIcmsCstCsosn.TRIBUTED_WITH_ICMS_SUBSTITUTION]: '10',
  [InvoiceIcmsCstCsosn.REDUCED_BASE]: '20',
  [InvoiceIcmsCstCsosn.EXEMPT_WITH_ICMS_SUBSTITUTION]: '30',
  [InvoiceIcmsCstCsosn.EXEMPT]: '40',
  [InvoiceIcmsCstCsosn.NOT_TRIBUTED]: '41',
  [InvoiceIcmsCstCsosn.SUSPENDED]: '50',
  [InvoiceIcmsCstCsosn.DEFERRED]: '51',
  [InvoiceIcmsCstCsosn.PREVIOUS_ICMS_SUBSTITUTION]: '60',
  [InvoiceIcmsCstCsosn.REDUCED_BASE_WITH_ICMS_SUBSTITUTION]: '70',
  [InvoiceIcmsCstCsosn.OTHERS]: '90',
  //---------------CSOSN---------------
  [InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITH_CREDIT_PERMISSION]: '101',
  [InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION]: '102',
  [InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE]: '103',
  [InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITH_CREDIT_PERMISSION_AND_ICMS_BY_TAX_SUBSTITUTION]:
    '201',
  [InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITHOUT_CREDIT_PERMISSION_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION]:
    '202',
  [InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE_RANGE_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION]:
    '203',
  [InvoiceIcmsCstCsosn.IMMUNITY]: '300',
  [InvoiceIcmsCstCsosn.NOT_TAXED_UNDER_SIMPLES]: '400',
  [InvoiceIcmsCstCsosn.ICMS_PREVIOUSLY_CHARGED_BY_TAX_SUBSTITUTION]: '500',
  [InvoiceIcmsCstCsosn.CSOSN_OTHERS]: '900',
};
